"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditScoreVerifiableTestFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var CreditScoreVerifiableTestFactory = /** @class */ (function (_super) {
    __extends(CreditScoreVerifiableTestFactory, _super);
    function CreditScoreVerifiableTestFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    CreditScoreVerifiableTestFactory.prototype.deploy = function (_creditScoreContract, overrides) {
        return _super.prototype.deploy.call(this, _creditScoreContract, overrides || {});
    };
    CreditScoreVerifiableTestFactory.prototype.getDeployTransaction = function (_creditScoreContract, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _creditScoreContract, overrides || {});
    };
    CreditScoreVerifiableTestFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    CreditScoreVerifiableTestFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    CreditScoreVerifiableTestFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return CreditScoreVerifiableTestFactory;
}(contracts_1.ContractFactory));
exports.CreditScoreVerifiableTestFactory = CreditScoreVerifiableTestFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_creditScoreContract",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DidSomethingAndProofPassed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DidSomethingOptionalProof",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "creditScoreContract",
        outputs: [
            {
                internalType: "contract ISapphireCreditScore",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "proofOptionalDoSomething",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "proofRequiredDoSomething",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=CreditScoreVerifiableTestFactory.js.map